module.exports = __webpack_public_path__ + "img/logo-light.e191376a.png";